import { Routes } from '@angular/router';
import { AppLayout } from '@spike/scaffolds';
import { canActivateAuthRole } from '@spike/core';
import { WalletPageComponent } from '../feature/pages/wallet-page/wallet-page';
import { TradePageComponent } from '../feature/pages/trade-page/trade-page';
import { InvestmentPageComponent } from '../feature/pages/investment-page/investment-page';
import { TradeRecapPageComponent } from '../feature/pages/trade-recap-page/trade-recap-page';
import { WalletHistoryPageComponent } from '../feature/pages/wallet-history-page/wallet-history-page';

export const routeConfig: Routes = [
  {
    path: '',
    component: AppLayout,
    canActivate: [canActivateAuthRole],
    children: [
      { path: 'wallets', component: WalletPageComponent, data: { title: 'Wallets'} },
      { path: 'wallets-progression', component: WalletHistoryPageComponent, data: { title: 'Storico patrimonio'} },
      { path: 'trades', component: TradePageComponent, data: { title: 'Liquidità'} },
      { path: 'trade-recap', component: TradeRecapPageComponent, data: { title: 'Recap'} },
      { path: 'investments', component: InvestmentPageComponent, data: { title: 'Investimenti'} },
      { path: '', redirectTo: 'wallets', pathMatch: 'full' }, // Default su /financial
      { path: '**', redirectTo: 'wallets' }
    ]
  }
];